const sideDishes = [

    { name: "Картопляне пюре", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Картопля по-селянські", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Картопля по-італійськи", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Картопля молода з маслом СЕЗОННО", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Картопляні крокети", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Картопля по-гуцульськи з сиром бринза", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 280, 
        price: 80, 
        image: "",
        ingredients: '' 
    },

    { name: "Кнедлі з тушеною капустою", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 400, 
        price: 90, 
        image: "",
        ingredients: '' 
    },

    { name: "Броколі під сирним соусом", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 370, 
        price: 280, 
        image: "",
        ingredients: '' 
    },

    { name: "Цвітна капуста в клярі", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 'за 100', 
        price: 30, 
        image: "",
        ingredients: '' 
    },

    { name: "Цвітна капуста в сухарях", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 'за 100', 
        price: 30, 
        image: "",
        ingredients: '' 
    },

    { name: "Цвітна капуста під сирним соусом", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 430, 
        price: 280, 
        image: "",
        ingredients: '' 
    },

    { name: "Асорті овочів гриль", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 200, 
        price: 200, 
        image: "",
        ingredients: '(печериці, баклажан, перець болгарський, цукіні)' 
    },

    { name: "Рис з овочами", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 250, 
        price: 150, 
        image: "",
        ingredients: '(горошок зелений, кукурудза, рис, масло)' 
    },

    { name: "Різотто з креветками", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 220, 
        price: 280, 
        image: "",
        ingredients: '(рис арбаріо, вершки, вино біле, креветки, яйце, сир пармезан)' 
    },

    { name: "Різотто з овочами", 
        category: 'Гарніри', 
        unit: ' г', 
        amount: 220, 
        price: 250, 
        image: "",
        ingredients: '(рис арбаріо, перець болгарський, морква, кукурудза с/м, квасоля стручкова, сир пармезан, вершки)' 
    },

];

export default sideDishes;